export const ApiRoutes = Object.freeze({
    LOGIN_ADMIN: "/api/rescuern-admin-login",
    ORGANIZATION_LISTING: "/api/organization-listing",
    ORGANIZATION_DETAILS: "/api/view-organization",
    ORGANIZATION_CREATE: "/api/create-organization",
    ORGANIZATION_EDIT: "/api/edit-organization",
    ADD_BUSINESS_ADMIN_USER: "/api/admin-business/create",
    ADD_COACH: "/api/add-coach",
    ADD_TEAM_MEMBER: "/api/add-team-member",
    EDIT_COACH: "/api/edit-coach",
    EDIT_TEAM_MEMBER: "/api/edit-team-member",
    VIEW_COACH_TEAM_MEMBER: "/api/view-coach-team-member",
    COACH_TEAM_MEMBER_LISTING: "/api/coach-team-listing-by-organization",
    LEAD_LISTING: "/api/contact-us-list",
    UPDATE_LEAD_STATUS: "/api/update-toggle",
    DASHBOARD_METRICS: "/api/dashboard-stats",
    RESOURCES_LISTING: "/api/get-all-content",
    ADD_RESOURCE: "/api/add-content",
    DELETE_RESOURCE: "/api/delete-content",
    // Below are the API endpoints for Business Leadership Application
    LOGIN_BUSINESS: "/api/admin-business/login",
    // Below are the API endpoints for Coach And Team Member Application
    LOGIN_COACH_TEAM_MEMBER: "/api/coach-team-member-login",
    // Below are the API endpoints for Attendance Management
    GET_ATTENDANCE: "/api/attendance",
    MARK_ATTENDANCE: "/api/attendance/mark",
    // Below are the API endpoints for Coach/Team Member Dashboard
    MY_COURSES: "/api/my-courses",
    // Below are the API endpoints for Schedule Management
    TRAININGS_BY_ORGANIZATION: "/api/trainings-by-organization",
    SCHEDULE_TRAINING: "/api/schedule-training",
    // Below are the API endpoints for Course Management
    GET_COURSES: "/api/get-courses",
    ASSIGN_COURSES: "/api/assign-courses",
    ASSIGNED_COURSES_BY_USER: "/api/assigned-courses-by-user",
    UPDATE_COURSE_PROGRESS: "/api/update-course-progress",
    // Pre-course survey
    PRE_COURSE_SURVEY: "/api/pre-course-survey",
    // Post-course survey
    POST_COURSE_SURVEY: "/api/post-course-survey",
    // In-person training feedback
    IN_PERSON_TRAINING_FEEDBACK: "/api/in-person-training-feedback",
    // RXN Ready course evaluation
    RXN_READY_COURSE_EVALUATION: "/api/in-person-training-feedback",
});